import React from 'react';

import { Box, Typography, styled } from '@liscio/ui';

import { config } from 'config';
import { COPYRIGHT_TEXT } from 'constants/settings';

export const FOOTER_BAR_HEIGHT = '53px';

interface CopyrightProps {
  /**
   * Visual variant.
   * - `inline` (default): centered text within the page flow (mobile).
   * - `bar`: full-width footer bar with a top border (desktop).
   */
  variant?: 'inline' | 'bar';
}

const InlineWrapper = styled(Box)(({ theme }) => ({
  textAlign: 'center',
  color: theme.palette.common?.neutrals?.[500] ?? theme.palette.text.secondary,
  paddingTop: '12px',
  paddingBottom: '12px',
}));

const BarWrapper = styled(Box)(({ theme }) => ({
  textAlign: 'center',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  background: theme.palette.common?.neutrals?.[100] ?? theme.palette.grey[100],
  height: FOOTER_BAR_HEIGHT,
  borderTop: `solid 1px ${
    theme.palette.common?.neutrals?.[200] ?? theme.palette.divider
  }`,
  width: '100%',
  color: theme.palette.common?.neutrals?.[500] ?? theme.palette.text.secondary,
  gap: '8px',
}));

export const Copyright = ({ variant = 'inline' }: CopyrightProps) => {
  const Wrapper = variant === 'bar' ? BarWrapper : InlineWrapper;
  return (
    <Wrapper>
      <Typography variant="caption">{COPYRIGHT_TEXT}</Typography>
      <Typography variant="caption">•</Typography>
      <Typography variant="caption">{config.version}</Typography>
    </Wrapper>
  );
};

export default Copyright;
